import React, { useState, useEffect, useRef, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { surgeryService } from '../../../services/surgeryService';
import { AutoCompleteUnControlled } from '../../Utils/FormInputs/AutoCompleteInput';

const SurgeonPicker = ({
  value = null,
  onChange,
  label = 'Lead Surgeon',
  filterSpecialty,
  filterType,
  disabled = false,
}) => {
  const [results, setResults] = useState([]);
  const debounceRef = useRef(null);

  const fetchDoctors = useCallback(
    (searchQuery) => {
      surgeryService
        .searchDoctors({ query: searchQuery })
        .then((res) => {
          let doctors = res.data?.doctors || res.data || [];
          if (filterSpecialty) {
            doctors = doctors.filter(
              (d) =>
                d.speciality &&
                d.speciality.toLowerCase().includes(filterSpecialty.toLowerCase())
            );
          }
          if (filterType === 'anaesthetist') {
            doctors = doctors.filter(
              (d) =>
                d.speciality &&
                d.speciality.toLowerCase().includes('anaesth')
            );
          }
          setResults(doctors);
        })
        .catch(() => {
          setResults([]);
        });
    },
    [filterSpecialty, filterType]
  );

  // Load all doctors on mount
  useEffect(() => {
    fetchDoctors('');
  }, []);

  const handleSearchChange = (query) => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(() => {
      fetchDoctors(query);
    }, 300);
  };

  return (
    <AutoCompleteUnControlled
      options={results}
      handleChange={handleSearchChange}
      handleProductData={(selected) => {
        if (onChange) onChange(selected);
      }}
      medicine_value={value}
      label_text="name"
      value_text="id"
      placeholder={label}
      disabled={disabled}
      id="surgeon-picker"
      name="surgeon_picker"
    />
  );
};

export default SurgeonPicker;
